
import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Descriptions, message } from 'antd';
import { Form, Select, Row, Col, Button, Input } from 'antd';
import { Link } from 'react-router-dom';

import {logout, comites, titular_comite_representante, agregar_comite_representante, eliminar_titular_comite_representante, actualizar_representante} from '../utils/JWTAuth';
import  NavBar  from './NavBar';
const { Option } = Select;
let comite, url, representante, state, comite_agregado, lista_comites, lista_titular_comites, campo_actualizar;

const success = (messages) => {
  message.success(messages);
};

const error = (messages) => {
  message.error(messages);
};

const warning = (messages) => {
  message.warning(messages);
};


function handleChange(value) {
  
  comite_agregado = value;

}

function handleChangeField(value){
  campo_actualizar = value;
}

function borrarComite(e){
  

  eliminar_titular_comite_representante(e.target.getAttribute('data-id-comite'),e.target.getAttribute('data-id-representante')).then(data => {
    if(data.success){

      //window.location.reload();
      
    }else{
      //window.location.href="/login";
    }
  });
}

class InfoRepresentante extends Component{

  constructor(props){
    super(props);
    
    state = this;

    this.state = {
      datos: []
    };

    this.pintarDatosUsuario();

  }

  

  pintarDatosUsuario(){
    titular_comite_representante(state.props.match.params.num_comite,state.props.match.params.usuario).then(data => {

      switch(data.status){
        case 0:

        state.setState({
          datos: data.data
        });
          break;
          case 5:
            error('Error de conexión');
            switch(state.props.match.params.num_comite){
              case 1: url = 'comite-nacional-seguridad-vial'; break;
              case 2: url = 'comite-prevencion-y-combate-al-delito'; break;
              case 3: url = 'comite-movilidad'; break;
              case 4: url = 'comite-ferroviario'; break;
              case 5: url = 'comite-juridico'; break;
              case 6: url = 'comite-tecnico'; break;
            }
        
            window.location.href = '/login/'+url+'/'+state.props.match.params.num_comite;
            break;
            
      }

     

    });
  }


  actualizarCampo(){
    

    let datos = {
      campo: campo_actualizar,
      valor: document.getElementById('actualiza_campo').value
    }

    

    actualizar_representante(state.props.match.params.num_comite,state.props.match.params.usuario, datos).then(data => {

      switch(data.status){
        case 0:
          success('Campo actualizado');
          break;
          case 5:
            error('Error de Conexión');
            break;
      }

      state.pintarDatosUsuario();



    });

  }

render(){
    return(


<Row>

<NavBar comite={state.props.match.params.num_comite} />
<Col span={18}>
  <Row style={{ margin:'20px 10px' }}>

  
      <Col span={6}>
        <Select style={{ width: '100%', margin:'5px 10px' }} onChange={handleChangeField}>
          <Option value="nombre">Nombre</Option>
          <Option value="cargo">Cargo</Option>
          <Option value="telefono">Teléfono</Option>
          <Option value="profesion">Profesión</Option>
        </Select>
      </Col>
      <Col span={6}>
      <Input style={{ width: '100%', margin:'5px 10px' }} id="actualiza_campo" />
      </Col>
      <Col span={4}>
        <Form.Item>
             
              <Button  onClick={this.actualizarCampo} type="primary">Editar</Button>
            </Form.Item>
      </Col>
      <Col span={6} offset={2}><Button  style={{ margin:'5px 10px' }} type="primary">
        <Link  to={`/representante/${state.props.match.params.num_comite}`}>Regresar</Link>
        </Button></Col>
      <Col span={20} style={{ textAlign:'Center'}}>
      <Descriptions title="Información" column={1} bordered>
        <Descriptions.Item label="Nombre">{state.state.datos.nombre} </Descriptions.Item>
        <Descriptions.Item label="Cargo">{state.state.datos.cargo}</Descriptions.Item>
        <Descriptions.Item label="E-mail">{state.state.datos.email}</Descriptions.Item>
        <Descriptions.Item label="Teléfono">{state.state.datos.telefono}</Descriptions.Item>
        <Descriptions.Item label="Profesión">{state.state.datos.profesion}</Descriptions.Item>
        <Descriptions.Item label="Fecha de Registro">{state.state.datos.created_at}</Descriptions.Item>
        {lista_comites}
      </Descriptions>
      </Col>
  </Row>
</Col>
      
     
    
     
    
    
   
</Row>

      
    );

}

          

}

export default InfoRepresentante;
